<iframe *ngIf="showPlaylist" class="playlistFrame" src="playlist/index.html"></iframe>
<div class="loader">
  <table style="width:100%; height:100%">
    <tbody>
      <tr>
        <td style="vertical-align:middle; text-align:center;"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></td>
      </tr>
    </tbody>
  </table>
</div>

<div class="playlistFrame" *ngIf="!showPlaylist">
  <table style="width:100%; height:100%">
    <tbody>
      <tr>
        <td style="vertical-align:middle; text-align:center;">seleziona un consulente per cominciare</td>
      </tr>
    </tbody>
  </table>
</div>
